import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mui/material';
import type { InventoryResource } from '@repo/api-gw-sdk';
import { Tag } from '@/components/tag';
import { useRoles } from '@/contexts/useRoles';
import { Environments } from '@/data/inventory/data';
import { AutoClassification } from './autoClassifcationButtons';
export const EnvironmentTag = t0 => {
  const $ = _c(5);
  const {
    environment
  } = t0;
  const t1 = Environments[environment]?.description ?? Environments[environment]?.title ?? environment;
  const t2 = Environments[environment]?.title ?? "Not Detected";
  let t3;
  if ($[0] !== t2) {
    t3 = <Tag variant="primary" content={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1 || $[3] !== t3) {
    t4 = <Tooltip title={t1}>{t3}</Tooltip>;
    $[2] = t1;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export function EnvironmentViewer(t0) {
  const $ = _c(37);
  const {
    entity,
    setEnvironmentDetectionOff,
    restartEnvironmentDetection
  } = t0;
  const {
    isAuthorizedResource
  } = useRoles();
  if (entity.classifications?.environmentDetails?.isOverridden) {
    let t1;
    if ($[0] !== restartEnvironmentDetection) {
      t1 = () => restartEnvironmentDetection();
      $[0] = restartEnvironmentDetection;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    let t3;
    if ($[2] !== setEnvironmentDetectionOff) {
      t2 = () => setEnvironmentDetectionOff();
      t3 = () => setEnvironmentDetectionOff();
      $[2] = setEnvironmentDetectionOff;
      $[3] = t2;
      $[4] = t3;
    } else {
      t2 = $[3];
      t3 = $[4];
    }
    let t4;
    if ($[5] !== entity || $[6] !== isAuthorizedResource) {
      t4 = isAuthorizedResource("update:environment_classification", entity);
      $[5] = entity;
      $[6] = isAuthorizedResource;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    const t5 = !t4;
    let t6;
    if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
      t6 = <AutoClassification testId="environment-auto-classification-buttons-override" textOn="" isAutoClassificationOn={false} restartDetectionClicked={t1} editOverridesClicked={t2} setEditorOpen={t3} disabled={t5} />;
      $[8] = t1;
      $[9] = t2;
      $[10] = t3;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    const t7 = entity.classifications?.environmentDetails?.environment ?? "";
    let t8;
    if ($[13] !== t7) {
      t8 = <EnvironmentTag environment={t7} />;
      $[13] = t7;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== t6 || $[16] !== t8) {
      t9 = <>{t6}{t8}</>;
      $[15] = t6;
      $[16] = t8;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    return t9;
  }
  const textOn = entity.classifications?.environmentDetails?.environment ? "This environment was detected:" : "No environment was detected";
  let t1;
  if ($[18] !== restartEnvironmentDetection) {
    t1 = () => restartEnvironmentDetection();
    $[18] = restartEnvironmentDetection;
    $[19] = t1;
  } else {
    t1 = $[19];
  }
  let t2;
  let t3;
  if ($[20] !== setEnvironmentDetectionOff) {
    t2 = () => setEnvironmentDetectionOff();
    t3 = () => setEnvironmentDetectionOff();
    $[20] = setEnvironmentDetectionOff;
    $[21] = t2;
    $[22] = t3;
  } else {
    t2 = $[21];
    t3 = $[22];
  }
  let t4;
  if ($[23] !== entity || $[24] !== isAuthorizedResource) {
    t4 = isAuthorizedResource("update:environment_classification", entity);
    $[23] = entity;
    $[24] = isAuthorizedResource;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  const t5 = !t4;
  let t6;
  if ($[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t5 || $[30] !== textOn) {
    t6 = <AutoClassification testId="environment-auto-classification-buttons-auto" textOn={textOn} isAutoClassificationOn={true} restartDetectionClicked={t1} editOverridesClicked={t2} setEditorOpen={t3} disabled={t5} />;
    $[26] = t1;
    $[27] = t2;
    $[28] = t3;
    $[29] = t5;
    $[30] = textOn;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  let t7;
  if ($[32] !== entity.classifications) {
    t7 = !!entity.classifications?.environmentDetails?.environment && Environments[entity.classifications?.environmentDetails?.environment] && <EnvironmentTag environment={entity?.classifications.environmentDetails.environment ?? ""} />;
    $[32] = entity.classifications;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== t6 || $[35] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[34] = t6;
    $[35] = t7;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  return t8;
}